import { Benefits } from "~landing/components/government/benefits";
import { Faqs } from "~landing/components/government/faqs";
import { Hero } from "~landing/components/government/hero";
import { HowItWorks } from "~landing/components/government/how-it-works";
import { StartBuilding } from "~landing/components/government/start-building";
import { Testimonials } from "~landing/components/government/testimonials";
import { UseCases } from "~landing/components/government/use-cases";
import { Layout } from "~landing/components/layout";

export function SolutionsGovernment() {
	return (
		<Layout>
			<main>
				<Hero />
				<Benefits />
				<UseCases />
				<Testimonials />
				<HowItWorks />
				<Faqs />
				<StartBuilding />
			</main>
		</Layout>
	);
}
